import React from 'react';
import { NavLink } from 'react-router-dom';

const ExpenseClaimsCrumb = () => (
  <NavLink to="/human-resources/expense-claims">Expense Claims</NavLink>
);

export default ExpenseClaimsCrumb;
